(() => {
  const pattern = /(^|[^\p{L}\p{N}])mod(?=$|[^\p{L}])/giu;
  const excluded = 'script,style,noscript,textarea,input,select,option,sup,svg,math,[contenteditable]:not([contenteditable="false"]),[data-mr-plain-text]';
  const formatText = (node) => {
    if (!node.parentElement || node.parentElement.closest(excluded)) return;
    const text = node.nodeValue;
    pattern.lastIndex = 0;
    const matches = [...text.matchAll(pattern)];
    if (!matches.length) return;
    const fragment = document.createDocumentFragment();
    let cursor = 0;
    for (const match of matches) {
      const start = match.index + match[1].length;
      fragment.append(document.createTextNode(text.slice(cursor, start)));
      const marker = document.createElement('sup');
      marker.className = 'mr-model-sup';
      marker.textContent = 'mod';
      fragment.append(marker);
      cursor = start + 3;
    }
    fragment.append(document.createTextNode(text.slice(cursor)));
    node.replaceWith(fragment);
  };
  const format = (root) => {
    if (!root.isConnected) return;
    if (root.nodeType === Node.TEXT_NODE) {
      formatText(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE || root.closest(excluded)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(formatText);
  };
  const start = () => {
    format(document.body);
    new MutationObserver((records) => {
      const roots = new Set();
      for (const record of records) {
        if (record.type === 'characterData') roots.add(record.target);
        else record.addedNodes.forEach((node) => roots.add(node));
      }
      roots.forEach(format);
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
